import React from "react";
import { AlertTriangle } from "lucide-react";

export interface DatesWarningBannerProps {
  title: string;
  message: string;
  linkLabel: string;
  onEdit: () => void;
}

/**
 * Yellow warning shown below the Summary when a re-entered draft's dates fall in
 * the past / within the lead time (F9, AC35/AC36). Channel-agnostic: the mount
 * supplies the H2H (distribution dates) or D2D (launch date) copy, with the lead
 * time interpolated. The Edit link returns to Targeting focused on the field.
 */
const DatesWarningBanner = ({ title, message, linkLabel, onEdit }: DatesWarningBannerProps) => (
  <div
    data-cypress-id="targeting-dates-warning"
    className="flex items-start gap-3 rounded-[10px] border border-solid border-[#fee685] bg-[#fffbeb] px-4 py-3 dark:border-[#973c00] dark:bg-[#461901]"
  >
    <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-[#7b3306] dark:text-[#fef3c6]" />
    <div className="flex flex-col gap-1 text-sm leading-5">
      <span className="font-medium text-[#7b3306] dark:text-[#fef3c6]">{title}</span>
      <span className="text-[#973c00] dark:text-[#fef3c6]">{message}</span>
      <button
        type="button"
        data-cypress-id="targeting-dates-warning-edit"
        onClick={onEdit}
        className="self-start bg-transparent p-0 text-left text-[#973c00] underline dark:text-[#fef3c6]"
      >
        {linkLabel}
      </button>
    </div>
  </div>
);

export { DatesWarningBanner };
